// ponytail: Case Map only; LOTPMap / QB keep full question lists until product asks otherwise.
export function caseMapVisibleQuestions<T extends { archived_at?: string | null; status?: string }>(
  questions: T[],
): T[] {
  return questions.filter((q) => !q.archived_at && q.status !== "retired");
}
